import { AssistantAnimation } from '@/components/SearchAssistant/components/AssistantAnimation';
import {
  AssistantMessageContainer,
  Message,
} from '@/components/SearchAssistant/components/Message';
import { TypingIndicator } from '@/components/SearchAssistant/components/TypingIndicator';
import { searchAssistantStore } from '@/stores/searchAssistantStore';
import { Box, Typography } from '@mui/material';
import { memo, useEffect, useRef } from 'react';

const styles = {
  messagesContainer: {
    position: 'relative',
    flex: 1,
    overflowY: 'hidden',
    backgroundColor: (theme) => theme.palette.baseColors.offWhite.c25,
  },

  scrollContainer: {
    scrollSnapType: 'y proximity',
    overflowY: 'scroll',
    height: '100%',
    scrollBehavior: 'smooth',
  },

  emptyState: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.875rem',
    color: (theme) => theme.palette.text.secondary,
    backgroundColor: (theme) => theme.palette.baseColors.offWhite.c25,
  },
};

export const Messages = memo(() => {
  const currentSessionId = searchAssistantStore.use.currentSessionId();
  const messages = searchAssistantStore((state) => state.messages[currentSessionId] || []);
  const isAssistantTyping = searchAssistantStore(
    (state) => state.isAssistantTyping[currentSessionId] || false,
  );
  const messagesContainerRef = useRef(null);

  useEffect(() => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  }, [messages, isAssistantTyping]);

  if (!messages.length && !isAssistantTyping) {
    return <Typography sx={styles.emptyState}>Ask me anything!</Typography>;
  }

  return (
    <Box as={'section'} sx={styles.messagesContainer} className="messages-container">
      <div style={styles.scrollContainer} ref={messagesContainerRef}>
        <AssistantAnimation
          onlyFrame={true}
          frameWidth={4.0}
          sx={{ filter: 'blur(4px)' }}
          animate={isAssistantTyping}
        />
        {messages.map((message) => (
          <Message
            key={message.id}
            id={message.id}
            role={message.role}
            content={message.content}
            status={message.status}
            createdAt={message.createdAt}
          />
        ))}
        {isAssistantTyping ? (
          <AssistantMessageContainer>
            <TypingIndicator />
          </AssistantMessageContainer>
        ) : null}
      </div>
    </Box>
  );
});
